
<template>
  <div>
    <v-row class="justify-center align-center">
      <v-col md='10' lg='7' class="mt-5">
        <div class="d-flex justify-center">
          <v-btn 
            color="blue-grey darken-1" class="white--text ml-3" 
            @click="$router.push({name: 'ProductsList'})" 
            v-if="['BrandsList', 'EditBrand', 'EditPickupLocation', 'EditProductPickupLocation'].includes($route.name)"
          ><v-icon small left>mdi-list-box</v-icon> Listar Produtos</v-btn>
  
          <v-btn 
            color="blue-grey darken-1" class="white--text ml-3"
            @click="$router.push({name: 'BrandsList'})" 
            v-if="['ProductsList', 'EditProduct'].includes($route.name)"
          ><v-icon small left>mdi-list-box</v-icon> Listar Fornecedores</v-btn>
      
          <v-btn
            color="blue-grey darken-1"
            class="white--text ml-3"
            aria-label="Recarregar conteúdo"
            @click="refreshNestedView"
          >
            <v-icon small left>mdi-refresh</v-icon>
            Recarregar
          </v-btn>

        </div>
    
        <router-view :key="nestedViewKey"></router-view>

      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'SupplierList',
  data() {
    return {
      nestedViewKey: 0,
    }
  },
  methods: {
    refreshNestedView() {
      this.nestedViewKey += 1
    },
  },
}
</script>